import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

import { isValidPhoneForCountry } from "../../utils/phone";

export const newProjectQuickSchema = z
    .object({
        name: z.string().min(1, "Project name is required"),
        type: z.string().min(1, "Project type is required"),
        salesmanName: z.any().refine((val) => !!val, {
            message: "Salesman is required",
        }),
        customerName: z.string().min(1, "Customer name is required"),
        customerPhoneCountry: z.enum(["US", "CA", "MX", "IN"]),
        customerPhoneNumber: z.string().min(1, "Customer phone number is required"),
        customerEmail: z
            .string()
            .refine((val) => !val || z.string().email().safeParse(val).success, {
                message: "Invalid email address",
            }),
        customerStreetAddress: z
            .string()
            .min(1, "Customer street address is required"),
        customerCity: z.string().min(1, "Customer city is required"),
        customerState: z.string().min(1, "Customer state is required"),
        customerZipCode: z.string().min(1, "Customer ZIP code is required"),
        customerCountry: z.string().min(1, "Customer county is required"),
    })
    .superRefine((data, ctx) => {
        if (!isValidPhoneForCountry(data.customerPhoneNumber, data.customerPhoneCountry)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: "Enter a valid phone number for the selected country",
                path: ["customerPhoneNumber"],
            });
        }
    });

export type NewProjectQuickFormValues = z.infer<typeof newProjectQuickSchema>;

const newProjectQuickResolver = zodResolver(newProjectQuickSchema);

export default newProjectQuickResolver;
